export default __webpack_public_path__ + "static/media/hero1.93af7d59.png";